<template>
  <ResultFileUpload></ResultFileUpload>
</template>

<script>
import { defineAsyncComponent } from "vue";
const ResultFileUpload = defineAsyncComponent(() =>
  import("@/components/results/AllResultsFileUpload")
);
export default {
  components: {
    ResultFileUpload,
  },
};
</script>
